import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { Baseproperties } from "src/app/views/utility/baseproperties";
import { EntityType } from "../../utility/modals";

@Injectable({ providedIn: 'root' })
export class EntitytypeService {
  constructor(private httpClient: HttpClient, private route: Router) { }
  baseproperties: Baseproperties = new Baseproperties();
  private baseURL = this.baseproperties.gatewayBaseURL + '/common/entitytype';

  postentitytype(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/createEntitytype`, payload);
  }
  modifyentitytype(payload: any): Observable<any> {
    return this.httpClient.put(`${this.baseURL}/updateEntitytype`, payload);
  }
  getall_entitytype(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/entitytypedata`);
  }
  getEntitytypeDataView_byId(id: number): Observable<EntityType> {
    return this.httpClient.get<EntityType>(`${this.baseURL}/findentitytype/${id}`);
  }
  entitytypeDataExcel() {
    return this.httpClient.get(`${this.baseURL}/entitytypeDataExcel`, { responseType: 'blob' });
  }
} 